export async function postData(url = "", data = {}) {
    const response = await fetch(url, {
      method: "POST",
      headers: {
          "Content-Type": "application/json",
          "Authorization": sessionStorage.getItem('token'),
      },
      redirect: "follow",
      body: JSON.stringify(data),
    });
    return response.json();
  };
